import { PageLayout } from '../components/PageLayout';
import { EcosystemSection } from '../components/sections/EcosystemSection';

export const Platform = () => (
    <PageLayout>
        <EcosystemSection />
    </PageLayout>
);
